import request from "@/utils/request";

export function loginVerifyCode(data) {
  return request({
    url: "/api/v1/fm/login/loginVerifyCode",
    method: "post",
    data
  });
}

export function login(data) {
  return request({
    url: "/api/v2/fm/login/public/login/web",
    method: "post",
    data,
    showLoading: false,
    showErrorMessage: false
  });
}

// 登录v2 预登陆，用于一个手机号绑定了多家企业的，获取企业列表手动选择登录哪个企业（再调用上面的login）
export function getUserCompanyList(data) {
  return request({
    url: "/api/v2/fm/login/public/prelogin/web",
    method: "post",
    data,
    showLoading: false
  });
}

export function menu(data) {
  return request({
    url: "/api/v1/fm/login/menu",
    method: "post",
    data,
    showLoading: false
  });
}

export function getLoginUserInfo(data) {
  return request({
    url: "/api/v1/fm/login/getLoginUserInfo?chatLoginInfo=1",
    method: "post",
    data,
    showLoading: false
  });
}

export function userLogout() {
  return request({
    url: "/api/v1/fm/login/logout",
    method: "post",
    data: {}
  });
}
// 获取验证码 验证码类型：1 登陆验证码 2 修改手机号验证码 3 设置密码验证码 4忘记密码验证码 5注册验证码 6设置手机号 7加入公司申请
export function getVerifyCode(data, showErrorMessage = true) {
  return request({
    url: "/api/v2/fm/login/public/verifyCode",
    method: "post",
    data,
    showLoading: false,
    showErrorMessage
  });
}
// 验证验证码
export function checkVerifyCode(data) {
  return request({
    url: "/api/v2/fm/login/public/check/code",
    method: "post",
    data
  });
}

export function editCellphone(data) {
  return request({
    url: "/api/v1/fm/login/editCellphone",
    method: "post",
    data
  });
}

export function checkVerifyCodeOld(data) {
  return request({
    url: "/api/v1/fm/login/checkVerifyCode",
    method: "post",
    data
  });
}

export function editAvatar(data) {
  return request({
    url: "/api/v1/fm/login/editAvatar",
    method: "post",
    data
  });
}

export function getMenuListByUser(data) {
  //获取用户权限菜单
  return request({
    url: "/api/v1/fm/login/getMenuListByUser",
    method: "post",
    data,
    showLoading: false
  });
}
